import { createContext, useContext, useState, ReactNode } from 'react'

import { AccountStatus, IUser } from 'cat-shared/utils'

type TAppContext = {
  isAppLoading: boolean
  setIsAppLoading: (isLoading: boolean) => void
  showAppDimmer: boolean
  setShowAppDimmer: (showAppDimmer: boolean) => void
  showAppNotifications: boolean
  setShowAppNotifications: (showAppNotifications: boolean) => void
  accountStatus: AccountStatus
  setAccountStatus: (status: AccountStatus) => void
  authUser: IUser | null
  setAuthUser: (user: IUser) => void
  recoverPassToken: string
  setRecoverPassToken: (token: string) => void
}

const AppContext = createContext<TAppContext>({} as TAppContext)

type Props = {
  children: ReactNode
}

export const AppContextProvider = ({ children }: Props) => {
  const [isAppLoading, setIsAppLoading] = useState<boolean>(true)
  const [showAppDimmer, setShowAppDimmer] = useState<boolean>(false)
  const [showAppNotifications, setShowAppNotifications] = useState<boolean>(false)
  const [accountStatus, setAccountStatus] = useState<AccountStatus | null>(null)
  const [authUser, setAuthUser] = useState<IUser | null>(null)
  const [recoverPassToken, setRecoverPassToken] = useState<string>('')

  return (
    <AppContext.Provider
      value={{
        isAppLoading,
        setIsAppLoading,
        showAppDimmer,
        setShowAppDimmer,
        showAppNotifications,
        setShowAppNotifications,
        accountStatus,
        setAccountStatus,
        authUser,
        setAuthUser,
        recoverPassToken,
        setRecoverPassToken,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export const useAppContext = () => {
  return useContext(AppContext)
}
